import {useContext} from 'react';

import {AudioPlaybackContext} from "../context/AudioPlaybackContext";

export default function useAudioPlayback() {
    const context = useContext(AudioPlaybackContext);
    if (!context) {
        throw new Error('useAudioPlayback must be used within a AudioPlaybackProvider');
    }
    return context;
}
